import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  DwConfigService, DwConfigServiceToken, DwOrmDataService, DwOrmDataServiceToken,
  DwTermsOfServiceManagerService
} from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AppMetaData, AssignmentStudentEntity, DocumentItemAcknowledgementEntity
} from '../../../meta-data/app-meta-data.service';
import { DateTimeUtilService } from '../../shared/util/date-time-util.service';
import { PostLoginExperience } from '../models/post-login-experience.model';

@Injectable({ providedIn: 'root' })
export class PostLoginRepositoryService {
  private readonly api: string;

  constructor(
    private http: HttpClient,
    @Inject(DwConfigServiceToken) config: DwConfigService,
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    private termsManager: DwTermsOfServiceManagerService,
    private dateTimeUtilService: DateTimeUtilService
  ) {
    this.api = `${config.coreConfig.apiRoot}/aviator-online/post-login`;
  }

  getExperience(onboardingOnly: boolean = false, useApplicationUser: boolean = false): Observable<PostLoginExperience> {
    const params: { [param: string]: string } = {};

    if (onboardingOnly) {
      params.onboardingOnly = 'true';
    }
    if (useApplicationUser) {
      params.useApplicationUser = 'true';
    }

    return this.http.get<PostLoginExperience>(this.api, { params });
  }

  acknowledgeTerms(): Observable<any> {
    return this.termsManager.acceptTermsOfService()
      .pipe(map(result => {
        if (!result?.IsSuccess) {
          throw new Error(result?.Message || 'Terms of Service acceptance failed.');
        }
        this.termsManager.termsOfServiceAccepted = true;
        return result;
      }));
  }

  acknowledgeDocuments(experience: PostLoginExperience): Observable<any> {
    const now = this.dateTimeUtilService.getCurrentDateTime();
    const entities = (experience.Documents || []).map(document => {
      const acknowledgement: DocumentItemAcknowledgementEntity = AppMetaData.DocumentItemAcknowledgement.CreateEntity();
      acknowledgement.DocumentItemId = document.DocumentItemId;
      acknowledgement.StudentId = experience.StudentId;
      acknowledgement.AcknowledgedDateTime = now;
      return acknowledgement;
    });
    return entities.length ? this.dwOrmDataService.saveEntityCollection(entities) : of(null);
  }

  acknowledgeAssignments(experience: PostLoginExperience): Observable<any> {
    const now = this.dateTimeUtilService.getCurrentDateTime();
    const entities = (experience.Assignments || []).map(assignment => {
      const entity: AssignmentStudentEntity = AppMetaData.AssignmentStudent.CreateEntity();
      entity.AssignmentStudentId = assignment.AssignmentStudentId;
      entity.Acknowledged = true;
      entity.AcknowledgedDateTime = now;
      return entity;
    });
    return entities.length ? this.dwOrmDataService.saveEntityCollection(entities) : of(null);
  }

  completeOnboarding(version: number): Observable<any> {
    return this.http.post(`${this.api}/onboarding/complete`, { Version: version });
  }
}
